var moduleMap = {
	"./mf-outlet": () => {
		return Promise.all([__webpack_require__.e(67557), __webpack_require__.e(54003), __webpack_require__.e(76386), __webpack_require__.e(14410), __webpack_require__.e(21357), __webpack_require__.e(92370), __webpack_require__.e(17263), __webpack_require__.e(65565), __webpack_require__.e(6490), __webpack_require__.e(45047), __webpack_require__.e(29008), __webpack_require__.e(97414), __webpack_require__.e(92733), __webpack_require__.e(67917), __webpack_require__.e(28416), __webpack_require__.e(31051), __webpack_require__.e(5439), __webpack_require__.e(99937), __webpack_require__.e(1154), __webpack_require__.e(63357), __webpack_require__.e(71968), __webpack_require__.e(1406), __webpack_require__.e(27460), __webpack_require__.e(82946), __webpack_require__.e(12797), __webpack_require__.e(26677), __webpack_require__.e(26749), __webpack_require__.e(77002)]).then(() => (() => ((__webpack_require__(8190)))));
	},
	"./routes": () => {
		return __webpack_require__.e(28086).then(() => (() => ((__webpack_require__(28086)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});